module.exports = __webpack_public_path__ + "img/logo-intl.79feb7f.png";